// DO NOT import from this file
// this is here to fix the issue where people where importing from the
// internals of the old Dropdown component
import { css } from "styled-components";

// Duplicate of the itemStyles from the original Dropdown.styles.ts
export const itemStyles = css<{ $isSelected?: boolean }>`
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 16px;
  padding-right: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  color: var(--mode-text-neutral-default-weak);
  border: 1px solid transparent;
  background-color: transparent;
  text-align: left;
  outline: none;
  border-radius: 4px;
  transition: 0.25s;
  cursor: pointer;

  display: flex;
  box-sizing: border-box;
  height: 32px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  :hover {
    background-color: var(--mode-bg-primary-weakest);
    color: var(--mode-text-primary-default);
  }

  :focus:not(:hover) {
    border: 1px solid var(--mode-neutral-border-weak-default);
    border-radius: 2px;
    background-color: var(--mode-bg-primary-weakest);
    color: var(--mode-text-primary-default);
  }

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      color: var(--mode-text-primary-default);

      :hover {
        color: var(--mode-text-primary-default);
      }
    `}
`;

// Duplicate of link styles from LinkItem.styles.ts
export const linkStyles = css`
  border: 1px solid transparent;
  outline: none;
  box-shadow: none;
  font-size: 15px;
  line-height: 24px;
  height: 32px;
  width: 100%;

  :after {
    content: none;
  }

  :hover {
    outline: none;
    border-color: transparent;
    box-shadow: none;
  }
`;
